/* eslint-disable react/jsx-no-bind */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
// eslint-disable-next-line no-use-before-define
import React, { useEffect, useState } from 'react';
import { Badge, Empty } from 'antd';
import {
  CheckCircleOutlined,
  ClearOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';

import controller from 'baseComponent/notificationCenter/controller';
import type { NotificationRecord } from 'baseComponent/notificationCenter/controller';

import './index.less';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store/combineReducers';

interface PopupProps {
  visible: boolean;
  onTrigger: () => void;
  children: React.ReactElement;
}

const TYPE_ICON_MAP = {
  open: (
    <InfoCircleOutlined style={{ color: 'var(--blue)', display: 'block' }} />
  ),
  success: (
    <CheckCircleOutlined style={{ color: 'var(--green)', display: 'block' }} />
  ),
  info: (
    <InfoCircleOutlined style={{ color: 'var(--blue)', display: 'block' }} />
  ),
  warning: (
    <ExclamationCircleOutlined
      style={{ color: 'var(--yellow)', display: 'block' }}
    />
  ),
  error: (
    <CloseCircleOutlined style={{ color: 'var(--red)', display: 'block' }} />
  ),
};

function Popup(props: PopupProps) {
  const { t } = useTranslation();
  const { visible, onTrigger, children } = props;
  const { vivalinkTheme, user } = useSelector(
    (state: ApplicationState) => state.session,
  );
  const [analyze, setAnalyze] = useState({
    error: 0,
    warning: 0,
    info: 0,
  });
  const [records, setRecords] = useState<NotificationRecord[]>([]);
  const handleClear = () => {
    controller.removeRecord();
  };

  const handleRemove = (id: string) => {
    controller.removeRecord(id);
  };

  const handleStopPropagation: React.MouseEventHandler<HTMLDivElement> = (
    e,
  ) => {
    e.nativeEvent.stopImmediatePropagation();
  };

  useEffect(() => {
    const handleUpdate = (newRecords: NotificationRecord[]) => {
      const newAnalyze = {
        error: 0,
        warning: 0,
        info: 0,
      };
      newRecords.forEach((record) => {
        if (record.type === 'error') {
          newAnalyze.error += 1;
        }
        if (record.type === 'warning') {
          newAnalyze.warning += 1;
        }
        if (record.type === 'info' || record.type === 'open') {
          newAnalyze.info += 1;
        }
      });

      setAnalyze(newAnalyze);
      setRecords(newRecords);
    };
    const currRecords = controller.readRecords();
    handleUpdate(currRecords);
    controller.on('update', handleUpdate);

    return () => {
      controller.off('update', handleUpdate);
    };
  }, [user]);

  useEffect(() => {
    if (visible === false) {
      const newRecords = controller.readRecords().map((record) => {
        return {
          ...record,
          readed: true,
        };
      });
      controller.writeRecords(newRecords);
    }
  }, [visible]);

  const title = (
    <div className="titleContainer">
      <div className="analyzeContainer">
        <div className="analyzeItem">
          {TYPE_ICON_MAP.error}
          <span>{analyze.error}</span>
        </div>
        <div className="analyzeItem">
          {TYPE_ICON_MAP.warning}
          <span>{analyze.warning}</span>
        </div>
        <div className="analyzeItem">
          {TYPE_ICON_MAP.info}
          <span>{analyze.info}</span>
        </div>
      </div>
      <div className="clear" onClick={handleClear}>
        <span>{t('common.clear')}</span>
      </div>
    </div>
  );
  let content;
  if (records.length <= 0) {
    content = <Empty description={false} style={{ padding: '16px' }} />;
  } else {
    content = records.map((item) => {
      return (
        <div
          key={item.id}
          className={`contentItem ${item.link ? 'linkItem' : ''}`}
        >
          {item.link && <a href={item.link} className="link" />}
          <div className="icon">{TYPE_ICON_MAP[item.type]}</div>
          <div className="itemContent">
            <h3>{item.title}</h3>
            <span className="desc">{item.description}</span>
            <span className="time">
              {dayjs(item.timestamp).format('YYYY-MM-DD HH:mm:ss')}
            </span>
          </div>
          {/* <div className="itemStatus">
            {item.readed ? null : <Badge status="processing" />}
          </div> */}
          <div className="itemDelete" onClick={() => handleRemove(item.id)}>
            <ClearOutlined />
          </div>
        </div>
      );
    });
  }

  return (
    <div
      className={`notification_center_popup_container ${
        vivalinkTheme !== 'light' ? 'dark' : ''
      }`}
      onClick={handleStopPropagation}
    >
      <div onClick={onTrigger}>{children}</div>

      <div
        className="popup"
        style={{
          display: visible ? 'block' : 'none',
        }}
      >
        {title}
        <div className="content">{content}</div>
      </div>
    </div>
  );
}

export default Popup;
